import { AzureKeyVault, IAttribute, IModel, LinkedService, Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';

@Metamodel.model({
    name: adfModelTypeMap.quickbase.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Quickbase_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Quickbase_DisplayText)
    ]
})
export class QuickbaseLinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static URL: IAttribute;
    public static USER_TOKEN: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ApplicationURL,
        templatable: true,
        association: 'URL'
    })
    public url: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Token,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        templatable: true,
        association: 'USER_TOKEN',
        accepts: ['String']
    })
    public userToken: string | AzureKeyVault;
}
